export enum SnackType {
  ERROR = 'error',
  INFO = 'info',
  WARN = 'warn',
}
